import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, PaginatedTable, PaginatedTableColumn, Section } from '@common/components';
import { formatDate } from '@common/utils';
import { GENETIC_COUNSELING_TRANSLATION } from '@modules/genetic-counseling/constants';
import { useReferralsTable } from '@modules/genetic-counseling/hooks';
import { DeclinedReferral, ReferralListItem, ReferralStatuses } from '@modules/genetic-counseling/types';
import BasicFilter from '../shared/BasicFilter/BasicFilter';

const Declined: FC = () => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);

  const {
    dataTable,
    commonColumns,
    pageSize,
    handleChangeSorting,
    handleChangePage,
    handleFilterChange,
    handleRowClick,
  } = useReferralsTable<DeclinedReferral>(ReferralStatuses.DECLINED);

  const columns: Array<PaginatedTableColumn<ReferralListItem> | PaginatedTableColumn<DeclinedReferral>> = [
    {
      key: 'dateTime',
      label: t('table.declined_date'),
      render: (_column: PaginatedTableColumn<DeclinedReferral>, item: DeclinedReferral) => {
        return item.declinedDateTime ? formatDate(item.declinedDateTime, 'MM/dd/yyyy') : '--';
      },
      sort: true,
      width: '16%',
    },
    ...commonColumns,
  ];

  return (
    <Section title={t('declined.section_title')}>
      <Box>
        <BasicFilter onFilterChange={handleFilterChange} />
        <PaginatedTable
          columns={columns}
          data={dataTable}
          isPaginated={false}
          onRowClick={handleRowClick}
          onSortingChange={handleChangeSorting}
          onPageChange={handleChangePage}
          pageSize={pageSize}
          rowClickable
        />
      </Box>
    </Section>
  );
};

export default Declined;
